type ClassValue = string | number | null | undefined | boolean;

export const cn = (...values: ClassValue[]): string =>
  values
    .flatMap((value) => {
      if (typeof value === 'string' || typeof value === 'number') {
        return value.toString();
      }
      return value ? [String(value)] : [];
    })
    .filter(Boolean)
    .join(' ');
